<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>
        <div class="mb-5" v-if="this.$store.getters.isAdmin">
            <label>Owner:</label>
            <treeselect placeholder="Select"
                        v-model="group.user"
                        :multiple="false"
                        :options="userList"
                        :load-options="loadUserList"
                        value-format="object"
            />
        </div>
        <div class="form-group">
            <label for="group_name" class="mt-2">Group Name:</label>
            <input v-model="group.name" type="text" class="form-control" id="group_name" name="group_name">
            <div class="text-danger" v-if="$v.group.name.$error">Group Name is required.</div>
        </div>
        <div class="form-group text-center p-b-20  p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import SmtpRelayGroupService from '../../services/SmtpRelayGroupService';
    import UserService from '../../services/UserService';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'SmtpRelayGroupForm',
        props: ['id'],
        components: {Treeselect},
        data() {
            return {
                group: {
                    name: null,
                    user: null
                },
                errors: {},
                showFailureMessage: false,
                userList: null,
                submitting: false
            }
        },
        mounted() {
            if (this.id) {
                SmtpRelayGroupService.getGroup(this.id).then(response => {
                    this.group = response.data;
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations: {
            group: {
                name: {required}
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                if (!this.group.user) {
                    delete this.group.user;
                }
                this.submitting = true;
                let submitMethod = null;
                if (this.id) {
                    submitMethod = SmtpRelayGroupService.updateGroup(this.id, JSON.stringify(this.group));
                } else {
                    submitMethod = SmtpRelayGroupService.createGroup(JSON.stringify(this.group));
                }

                submitMethod.then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'smtpRelayGroups'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            }
        }
    }
</script>

<style scoped>

</style>
